import { withAuth } from '@utilities/queries';
import { createRecentlyViewedCompany } from '@simplywallst/services';

export default async function mutationFn(payload: {
  uniqueSymbol: string;
}): Promise<void> {
  try {
    await withAuth(createRecentlyViewedCompany, payload);
  } catch (error) {
    throw error;
  }
}
